import UltMeta, { Meta } from "./UltMeta/index";
class NoticeType extends UltMeta {
    SHIP = new Meta(4, "运单");
    RECOMMEND = new Meta(6, "推荐");
    REMIND = new Meta(5, "提醒");
    NOTIFICATION = new Meta(7, "通知");
}
export const NOTICE_TYPE = new NoticeType();

class NoticeState extends UltMeta {
    UNREAD = new Meta(1, "未读");
    READ = new Meta(2, "已读");
    DELETE = new Meta(3, "已删除");
}
export const NOTICE_STATE = new NoticeState();

class NotificationState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    PENDING = new Meta(2, "待发布");
    PUBLISHED = new Meta(3, "已发布");
}
export const NOTIFICATION_STATE = new NotificationState();

/**
 *发布端类型
 */
class PublishPlat extends UltMeta {
    SHIPPING_PC = new Meta(1, "船务PC端");
    SHIPPING_TERMINAL = new Meta(2, "船务移动端");
}

export const PUBLISH_PLAT = new PublishPlat();
/**
 *发布类型
 */
class ReadState extends UltMeta {
    UNREAD = new Meta(1, "未读");
    READ = new Meta(2, "已读");
    DELETED = new Meta(3, "已删除");
}
export const READ_STATE = new ReadState();

class FlagState extends UltMeta {
    READ = new Meta(2, "已读");
    DELETE = new Meta(3, "删除");
}
export const FLAG_STATE = new FlagState();

// 消息类型
class MessageType extends UltMeta {
    TRANSACTION = new Meta(1, "交易");
    TRANSFORM = new Meta(2, "物流");
    OTHER = new Meta(3, "其他");
    TRANSPORT_ORDER = new Meta(4, "运单");
    REMIND = new Meta(5, "提醒");
    RECOMMEND = new Meta(6, "推荐");
}
export const MESSAGE_TYPE = new MessageType();

class NoticeClassify extends UltMeta {
    SYSTEM = new Meta(1, "系统通知");
    OPERATION = new Meta(2, "运营消息");
}
export const NOTICE_CLASSIFY = new NoticeClassify();

// 砂石用的
/**
 *通知类型
 */
 class NotificationType extends UltMeta {
    SYSTEM_NOTIFICATION = new Meta(1, "系统通知");
    OPERATIONAL_NOTIFICATION = new Meta(2, "运营通知");
}
export const NOTIFICATION_TYPE = new NotificationType();

/**
 *发布类型
 */
 class PublishStatus extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    PENDING = new Meta(2, "待发布");
    PUBLISHED = new Meta(3, "已发布");
}
export const PUBLISH_STATUS = new PublishStatus();

/**
 *后台-发布端类型
 */
class AdminPublishPlat extends UltMeta {
    SHIPPING_ALL = new Meta(0, "全部");
    SHIPPING_PC = new Meta(1, "船务PC端");
    SHIPPING_TERMINAL = new Meta(2, "船务移动端");
    SAND_PC = new Meta(3, "砂石PC端");
    SAND_TERMINAL = new Meta(4, "砂石移动端");
}

export const ADMIN_PUBLISH_PLAT = new AdminPublishPlat();

/**
 *后台-发布端类型
 */
class AdminPublishPlatSand extends UltMeta {
    SHIPPING_ALL = new Meta(0, "全部");
    SAND_PC = new Meta(3, "砂石PC端");
    SAND_TERMINAL = new Meta(4, "砂石移动端");
}

export const ADMIN_PUBLISH_PLAT_SAND = new AdminPublishPlatSand();